import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '../../../../_metronic/helpers'
import { useAuth } from '../../auth'
import { MyPolicy, OnityPolicyData } from '../../auth/core/_models'
import { WilliamsleaBaseEnrollmentForm } from './WilliamsleaBaseEnrollmentForm'

type Props = {
  show: boolean
  handleClose: () => void
  Title: string
  Email: string | undefined
  CrmUrl: string | undefined
  MyPolicy: MyPolicy | null
}

export const WilliamsleaBaseEnrollmentListModel: React.FC<Props> = ({ show, handleClose, Title, Email, CrmUrl, MyPolicy }) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const [policyData, setPolicyData] = useState<OnityPolicyData[] | null>(null)
  const { currentUser } = useAuth()

  const crmDbName = MyPolicy?.Policy.CrmDbName

  useEffect(() => {
    if (!show) {
      setPolicyData(null)
      setError(null)
      return
    }

    let cancelled = false
    const fetchPolicyData = async () => {
      setLoading(true)
      setError(null)
      try {
        const response = await fetch('https://etl.futurisk.in/webhook/23159409-2334-412d-aacc-1dcc87dfb325', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(currentUser?.sessioncode ? { SessionCode: currentUser.sessioncode } : {}),
          },
          body: JSON.stringify({
            Email: Email,
            CorporateCode: crmDbName,
          }),
        })
        if (!response.ok) throw new Error('Failed to fetch family details')
        const responseData = await response.json()
        const data: OnityPolicyData[] = Array.isArray(responseData) ? responseData : [responseData]
        if (!cancelled) setPolicyData(data)
      } catch (err: any) {
        if (!cancelled) setError(err.message || 'An unexpected error occurred')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    fetchPolicyData()
    return () => { cancelled = true }
  }, [show, Email, crmDbName, currentUser?.sessioncode])

  const dissmissLocation = () => {
    handleClose()
  }

  return (
    <Modal
      className='modal fade'
      id='kt_modal_williamslea'
      data-backdrop='static'
      tabIndex={-1}
      role='model'
      show={show}
      dialogClassName='modal-xl modal-dialog-scrollable'
      aria-hidden='true'
      onHide={dissmissLocation}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>
            {((policyData?.[0] as any)?.Freeze === false || policyData?.[0]?.freezeEnrolment === false) ? 'Enroll Family' : Title}
          </h5>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={dissmissLocation}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          {loading ? (
            <div className='text-center'>
              <div className='spinner-border text-primary' role='status'>
                <span className='sr-only'>Loading...</span>
              </div>
            </div>
          ) : error ? (
            <div className='text-danger text-center'>{error}</div>
          ) : ((policyData?.[0] as any)?.Freeze === false || policyData?.[0]?.freezeEnrolment === false) ? (
            <WilliamsleaBaseEnrollmentForm
              policyData={{ ...policyData![0], Email: policyData![0].Email || Email || '' }}
              policyEffectiveDate={MyPolicy?.Policy.PolicyEffectiveDate}
              policyExpiryDate={MyPolicy?.Policy.ExpiryDate}
              policyCrmDbName={MyPolicy?.Policy.CrmDbName}
              initialDependents={policyData as any}
              onSuccess={() => handleClose()}
            />
          ) : (
            <WilliamsleaBaseEnrollmentForm
              policyData={{
                ...policyData?.[0],
                Grade: policyData?.[0]?.Grade || '',
                freezeEnrolment: true,
                Email: Email || '',
              } as any}
              policyEffectiveDate={MyPolicy?.Policy.PolicyEffectiveDate}
              policyExpiryDate={MyPolicy?.Policy.ExpiryDate}
              policyCrmDbName={MyPolicy?.Policy.CrmDbName}
              preloadedMembers={policyData as any}
              onSuccess={() => handleClose()}
            />
          )}
        </div>
      </div>
    </Modal>
  )
}
